import { isZoom } from "~/lib/utils";

export default function recaptcha(action: string) {
	return new Promise<string>((resolve, _reject) => {
		if (!window.RECAPTCHA_ENABLED || isZoom) return resolve("");

		if (typeof window.grecaptcha === "undefined") {
			// @ts-ignore
			window.grecaptcha = {};
		}

		/* eslint-disable no-underscore-dangle */
		window.grecaptcha.ready = function (cb) {
			if (typeof window.grecaptcha === "undefined") {
				// window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
				// configuration. By default, any functions listed in its 'fns' property
				// are automatically executed when reCAPTCHA loads.
				window.___grecaptcha_cfg = window.___grecaptcha_cfg || {}; // eslint-disable-line camelcase
				(window.___grecaptcha_cfg["fns"] = window.___grecaptcha_cfg["fns"] || []).push(cb);
			} else {
				cb();
			}
		};
		/* eslint-enable no-underscore-dangle */

		window.grecaptcha.ready(async function () {
			const token = await grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action });
			resolve(token);
		});
	});
}
